import { createTheme } from '@mui/material/styles';

// 学术精致风格配色
const colors = {
  primary: {
    main: '#2D5A4A',      // 墨绿 - 主色调
    light: '#4A7C6F',
    dark: '#1E3D31',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#C9A227',      // 金色 - 点缀
    light: '#D4B84A',
    dark: '#A68820',
    contrastText: '#1A1A1A',
  },
  background: {
    default: '#FAF9F6',   // 米白背景
    paper: '#FFFFFF',
    elevated: '#F5F4F1',
  },
  text: {
    primary: '#1A1A1A',
    secondary: '#4A4A4A',
    muted: '#7A7A7A',
  },
  accent: {
    warm: '#E8DCC8',      // 暖米色
    cool: '#E0E5E3',      // 冷灰绿
    highlight: '#F5EFE6', // 浅米黄
  },
  sentiment: {
    positive: '#2D5A4A',
    negative: '#9B2C2C',
    neutral: '#6B7280',
    mixed: '#C9A227',
  }
};

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: colors.primary,
    secondary: colors.secondary,
    background: colors.background,
    text: colors.text,
  },
  typography: {
    fontFamily: '"Noto Sans SC", "Inter", sans-serif',
    h1: {
      fontFamily: '"Noto Serif SC", "Playfair Display", serif',
      fontWeight: 600,
      letterSpacing: '-0.02em',
    },
    h2: {
      fontFamily: '"Noto Serif SC", "Playfair Display", serif',
      fontWeight: 600,
      letterSpacing: '-0.01em',
    },
    h3: {
      fontFamily: '"Noto Serif SC", serif',
      fontWeight: 600,
    },
    h4: {
      fontFamily: '"Noto Serif SC", serif',
      fontWeight: 500,
    },
    h5: {
      fontFamily: '"Noto Sans SC", sans-serif',
      fontWeight: 600,
    },
    h6: {
      fontFamily: '"Noto Sans SC", sans-serif',
      fontWeight: 500,
    },
    subtitle1: {
      fontWeight: 400,
      letterSpacing: '0.01em',
    },
    button: {
      fontWeight: 500,
      letterSpacing: '0.02em',
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
          padding: '10px 24px',
          fontSize: '0.95rem',
        },
        contained: {
          boxShadow: '0 2px 8px rgba(45, 90, 74, 0.2)',
          '&:hover': {
            boxShadow: '0 4px 12px rgba(45, 90, 74, 0.3)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 2px 12px rgba(0, 0, 0, 0.06)',
          border: '1px solid rgba(0, 0, 0, 0.06)',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          '&:hover': {
            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
            transform: 'translateY(-2px)',
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          fontWeight: 500,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 10,
            backgroundColor: '#FFFFFF',
            '& fieldset': {
              borderColor: 'rgba(0, 0, 0, 0.1)',
            },
            '&:hover fieldset': {
              borderColor: colors.primary.main,
            },
            '&.Mui-focused fieldset': {
              borderColor: colors.primary.main,
              borderWidth: 2,
            },
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF',
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
        },
      },
    },
  },
});

export default theme;
export { colors };
